import React, { FC, useState } from 'react';
import s from './SymphonyHeader.scss';
import dataHooks from '../constants/data-hooks';
import OrbitMark from './OrbitMark';
import WixByLogo from '../../assets/images/symphonyLogo/wixByLogo.svg';

const HOME_URL = 'https://www.symphony.co';

const NAV_LINKS = [
  { label: 'User stories', href: HOME_URL },
  { label: 'Resources', href: HOME_URL },
  { label: 'Pricing', href: HOME_URL },
];

const Logo: FC = () => (
  <a className={s.logo} href={HOME_URL} aria-label="Symphony by Wix">
    <span className={s.orbit}>
      <OrbitMark />
    </span>
    <span className={s.logoText}>Symphony</span>
    <span className={s.by}>By</span>
    <span className={s.wix}>
      <WixByLogo />
    </span>
  </a>
);

const SymphonyHeader: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className={s.header} data-hook={dataHooks.symphonyHeader}>
      <div className={s.island}>
        <div className={s.row}>
          <div className={s.leftGroup}>
            <Logo />
            <nav className={s.nav}>
              {NAV_LINKS.map((link) => (
                <a key={link.label} className={s.navLink} href={link.href}>
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
          <div className={s.actions}>
            <a className={s.login} href={HOME_URL}>
              Log in
            </a>
            <a className={s.cta} href={HOME_URL}>
              Try for free
            </a>
            <button
              type="button"
              className={s.menuButton}
              data-hook={dataHooks.symphonyMenuButton}
              aria-label="Menu"
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen((open) => !open)}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
        {isMenuOpen && (
          <nav className={s.mobileMenu}>
            {NAV_LINKS.map((link) => (
              <a key={link.label} className={s.navLink} href={link.href}>
                {link.label}
              </a>
            ))}
            <a className={s.navLink} href={HOME_URL}>
              Log in
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default SymphonyHeader;
